import React, { FC } from 'react'
import styles from './Waiting.module.scss'
import { cx } from '../../../utils/cx';

interface WaitingProps {
    text: string;
    stacked?: boolean;
}

export const Waiting: FC<WaitingProps> = ({ text, stacked }) => (
    <div className={cx(styles.load, stacked && styles.loadStacked)}>
        <span className={styles.spinner} />
        {text}
    </div>
);